import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import {
	switchMap,
	map,
	catchError,
} from 'rxjs/operators';
import {
	actionTypes,
	conversationActions,
	notifyActions,
} from '../../../controller';
import {
	catchErrorForEpics,
} from '../../../../lib/epic-utils';

const {
	START_CREATE_CONVERSATION,
} = actionTypes;
const {
	notifyErrorAction,
} = notifyActions;
const {
	createConversationSuccessAction,
	createConversationFailedAction,
} = conversationActions;
const fakeConversationId = '5ec5f60b25fbb049dbd231e1';

export function createConversationEpic(action$) {
	return action$.pipe(
		ofType(START_CREATE_CONVERSATION),
		switchMap(() =>
			of([fakeConversationId]).pipe(
				map((payload = []) => createConversationSuccessAction(payload[0])),
				catchError(error => catchErrorForEpics(error, createConversationFailedAction, notifyErrorAction)),
			),
		),
	);
}
